<template>
  <div>
    <div class="text-body-medium font-weight-bold d-flex justify-center px-0 mt-12 text-primary">
      {{ title }}
    </div>
    <div class="text-body-medium d-flex justify-center px-0 mt-2 mb-5 text-secondary">
      {{ subtitle }}
    </div>

    <div class="d-flex justify-center px-0 mb-2">
      <v-icon size="36">
        {{ icon }}
      </v-icon>
    </div>

    <v-btn
      class="d-flex justify-center mx-auto mb-12 text-body-medium"
      color="primary"
      @click="handleClick"
    >
      {{ btnLabel }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { TrackingPlugin } from '@/plugins/tracking'
defineProps<{
  title: string
  subtitle: string
  btnLabel: string
  icon?: string
}>()

const emit = defineEmits<{
  (e: 'openPage'): void
}>()

const tracking = inject<TrackingPlugin>('tracking')!

const handleClick = () => {
  tracking?.event('Dashboard', 'Clicked', 'EmptyState', 'OpenPage')
  emit('openPage')
}
</script>
